import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kabikcoin'
})
export class CalculoKabicoinPipe implements PipeTransform {
  transform(PuntosKBCoin: number, cantidad?: number): number {
    return PuntosKBCoin * cantidad;
  }
}
